<template>
  <FormLayout title="Choose a location" @on-dismiss="handleDismiss">
    <vs-wrapper class="px-5">
      <location-card
        v-for="id in locationIds"
        :key="id"
        :location-id="id"
        :link-to="{
          name: 'fvnext-info-panel',
          params: { id, source: 'locations' },
        }"
      />
    </vs-wrapper>
  </FormLayout>
</template>

<script setup lang="ts">
import LocationCard from './LocationCard.vue'
import FormLayout from '../common/FormLayout.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'

defineProps<{
  title?: string
  locationIds: string[]
}>()

const emits = defineEmits<{
  (e: 'dismiss')
}>()

const handleDismiss = () => {
  emits('dismiss')
}
</script>
